import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'slack',
  version: '2.3.0',
  properties: [
    // Properties will be defined based on n8n equivalents
  ]
};

export default schema;
